<template>
  <div>
    <modal size="lg" :show.sync="openEntity" header-classes="bg-primary p-3">
      <h6 slot="header" class="modal-title text-white font-semibold pt-1">
        Add Entity ID
      </h6>
      <AddEmailTemplateEntity />
      <template slot="footer">
        <base-button type="primary">Create New Entity</base-button>
        <base-button
          type="secondary"
          class="ml-auto"
          @click="openEntity = false"
          >CLOSE</base-button
        >
      </template>
    </modal>
    <div class="flex items-center cursor-pointer">
      <feather-icon icon="ChevronLeftIcon" class="mr-2"></feather-icon>
      <p class="font-semibold">Back</p>
    </div>

    <div class="mt-8">
      <div class="flex">
        <div class="w-3/5 pr-3">
          <base-input
            class="w-full"
            label="Template Name"
            placeholder="Enter Template Name"
          >
            <b-input placeholder="Enter Template Name" />
          </base-input>

          <base-input class="w-full" label="Sender Name">
            <b-input placeholder="Enter Sender Name" />
          </base-input>

          <base-input class="w-full mb-4" label="Message Type">
            <select class="form-control" v-model="messageType">
              <option>Please Call Action</option>
              <option>Image</option>
              <option>Video</option>
            </select>
          </base-input>

          <base-input class="w-full mb-4" label="Choose Image">
            <b-form-file
              @change="filesChange"
              placeholder="Select file"
              drop-placeholder="Drop file here..."
            ></b-form-file>
          </base-input>

          <base-input
            v-if="messageType === 'Video'"
            class="w-full mb-4"
            label="Choose Video"
          >
            <b-form-file
              @change="filesChange"
              placeholder="Select file"
              drop-placeholder="Drop file here..."
            ></b-form-file>
          </base-input>

          <base-input
            class="w-full mb-4"
            label="Title "
            placeholder="Enter Tittle "
          >
            <b-input placeholder="Enter Template Name" />
          </base-input>

          <base-input
            class="w-full"
            label="Description"
            placeholder="Place your content here in details so that user can understand your service"
          >
            <textarea
              class="form-control"
              id="exampleFormControlTextarea3"
              rows="3"
            ></textarea>
          </base-input>

          <div class="bg-f4f5f6 px-4 pt-2">
            <p class="font-semibold mb-4">Action Links</p>
            <div class="flex">
              <div class="w-1/2 lg:pr-3 md:pr-3">
                <base-input
                  class="w-full"
                  label="Link To Open "
                  placeholder="Enter Title "
                >
                  <b-input placeholder="https://example.com" />
                </base-input>
              </div>

              <div class="w-1/2 lg:pl-3 md:pl-3">
                <base-input
                  class="w-full"
                  label="Button Text "
                  placeholder="Visit Website "
                >
                  <b-input placeholder="Enter Template Name" />
                </base-input>
              </div>
            </div>
          </div>

          <TextEditor />

          <base-button block type="primary" class="text-lg mt-4"
            >Create Template</base-button
          >
        </div>

        <div class="w-2/5 pl-3">
          <b-card no-body class="rounded-xl p-3">
            <b-card-text
              class="font-semibold border-bottom pb-2 cursor-pointer"
            >
              Preview</b-card-text
            >
            <b-card-body>
              <img
                src="../../img/temp1.png"
                class="w-full"
                alt="templatepriview"
              />
            </b-card-body>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AddEmailTemplateEntity from "./AddEmailTemplateEntity";
import TextEditor from "./TextEditor";
export default {
  data() {
    return {
      openEntity: false,
      messageType: "",
    };
  },
  components: {
    AddEmailTemplateEntity,
    TextEditor,
  },
};
</script>
